import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { environment } from '../../../environments/environment';

export const localOnlyGuard: CanActivateFn = () => {
  const router = inject(Router);

  return environment.name === 'local'
    ? true
    : router.parseUrl('/access-denied');
};
